import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SQLAlchemyIcon from "../img/icons/sqlalchemyicon.png";
import GitpodIcon from "../img/icons/gitpodicon.png";
import TailwindIcon from "../img/icons/tailwindicon.png";
import PostmanIcon from "../img/icons/postmanicon.png";
import TypescriptIcon from "../img/icons/typescripticon.png";
import VSCIcon from "../img/icons/visualstudiocodeicon.png";
import APIIcon from "../img/icons/apiicon.png";
import { ArrowDownIcon, ArrowIcon } from "./ArrowIcon";
import i18next from 'i18next';

import { faDatabase, faPepperHot } from "@fortawesome/free-solid-svg-icons";
import { faAws, faBootstrap, faCss3Alt, faGitAlt, faGithub, faHtml5, faJava, faJs, faNode, faNpm, faPython, faReact } from "@fortawesome/free-brands-svg-icons";

export const Technologies = () => {

    const [showText, setShowText] = useState(false);

    const handleArrowClick = (id) => {

        const element = document.getElementById(id);
        
        if (element) {
            setShowText(!showText);
            if (showText) {
                element.style.display = "none";
            } else {
                element.style.display = "flex";
            }
        }
    };

    return (
        <>
            <div className="text-center d-flex align-items-center flex-column text-white">
                <h1 className="section-title">
                    {i18next.t('technologies')}
                </h1>
                <div className="section-content flex-column gap-2 mt-4" id="technologiesContent">
                    <div className="tech-content">
                        <div className="tech-title" onClick={() => handleArrowClick("frontend")} >
                            <h3 className="tech-size">Frontend</h3>
                            { window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon /> }
                        </div>
                        <div className="tech-icons-list" id="frontend">
                            <a href="https://developer.mozilla.org/en-US/docs/Web/HTML" alt="HTML5" className="btn btn-background text-white" target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faHtml5} size="4x" />
                                    <span className="pt-2">HTML5</span>
                                </div>
                            </a>
                            <a href="https://developer.mozilla.org/en-US/docs/Web/CSS" alt="CSS3" className="btn btn-background text-white" target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faCss3Alt} size="4x" />
                                    <span className="pt-2">CSS3</span>
                                </div>
                            </a>
                            <a href="https://developer.mozilla.org/es/docs/Web/JavaScript" alt="Javascript" className="btn btn-background text-white" target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faJs} size="4x" />
                                    <span className="pt-2">Javascript</span>
                                </div>
                            </a>
                            <a href="https://react.dev/" alt="React" className="btn btn-background text-white" target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faReact} size="4x" />
                                    <span className="pt-2">React</span>
                                </div>
                            </a>
                            <a href="https://www.npmjs.com/" alt="npm" className="btn btn-background text-white" target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faNpm} size="4x" />
                                    <span className="pt-2">npm</span>
                                </div>
                            </a>
                            <a href="https://getbootstrap.com/" alt="Bootstrap" className="btn btn-background text-white" target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faBootstrap} size="4x" />
                                    <span className="pt-2">Bootstrap</span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="tech-content">
                        <div className="tech-title" onClick={() => handleArrowClick("backend")}>
                            <h3 className="tech-size">Backend</h3>
                            { window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon /> }
                        </div>
                        <div className="tech-icons-list" id="backend">
                            <a href="https://www.python.org/" alt="Python" className="btn btn-background text-white" target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faPython} size="4x" />
                                    <span className="pt-2">Python</span>
                                </div>
                            </a>
                            <a href="https://nodejs.org/en" alt="NodeJS" className="btn btn-background text-white" target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faNode} size="4x" />
                                    <span className="pt-2">NodeJS</span>
                                </div>
                            </a>
                            <a href="https://es.wikipedia.org/wiki/SQL" alt="SQL" className="btn btn-background text-white" target="_blank" rel="noreferrer" >
                                <div className="d-flex flex-column align-items-center">
                                <FontAwesomeIcon icon={faDatabase} size="4x" />
                                <span className="pt-2">SQL</span>
                                </div>
                            </a>
                            <a
                                href="https://flask.palletsprojects.com/en/3.0.x/"
                                alt="Flask"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <FontAwesomeIcon icon={faPepperHot} size="4x" />
                                <span className="pt-2">Flask</span>
                                </div>
                            </a>
                            <a
                                href="https://www.sqlalchemy.org/"
                                alt="SQLAlchemy"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <img
                                    type="button"
                                    style={{
                                    width: "70px",
                                    height: "auto",
                                    }}
                                    src={SQLAlchemyIcon}
                                    alt="SQLAlchemy logo"
                                ></img>
                                <span className="pt-2">SQLAlchemy</span>
                                </div>
                            </a>
                            <a
                                href="https://jwt.io/"
                                alt="JSON Web Tokens"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <img
                                    type="button"
                                    style={{ maxWidth: "100px", width: "100%", height: "50px" }}
                                    src="https://jwt.io/img/logo.svg"
                                    alt="JWT logo"
                                ></img>
                                <span className="pt-2">JWT</span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="tech-content">
                        <div className="tech-title" onClick={() => handleArrowClick("tools")}>
                            <h3 className="tech-size">{i18next.t('tools')}</h3>
                            { window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon /> }
                        </div>
                        <div className="tech-icons-list" id="tools">
                            <a
                                href="https://git-scm.com/"
                                alt="Git"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <FontAwesomeIcon icon={faGitAlt} size="4x" />
                                <span className="pt-2">Git</span>
                                </div>
                            </a>
                            <a
                                href="https://github.com/"
                                alt="Github"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <FontAwesomeIcon icon={faGithub} size="4x" />
                                <span className="pt-2">Github</span>
                                </div>
                            </a>
                            <a
                                href="https://www.gitpod.io/"
                                alt="Gitpod"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <img
                                    type="button"
                                    style={{ maxWidth: "50px", width: "100%" }}
                                    src={GitpodIcon}
                                    alt="GitPod logo"
                                ></img>
                                <span className="pt-2">Gitpod</span>
                                </div>
                            </a>
                            <a
                                href="https://www.postman.com/"
                                alt="Postman"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <img
                                    type="button"
                                    style={{ maxWidth: "50px", width: "100%" }}
                                    src={PostmanIcon}
                                    alt="Postman logo"
                                ></img>
                                <span className="pt-2">Postman</span>
                                </div>
                            </a>
                            <a
                                href="https://code.visualstudio.com/"
                                alt="Visual Studio Code"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <img
                                    type="button"
                                    style={{ maxWidth: "50px", width: "100%" }}
                                    src={VSCIcon}
                                    alt="Visual Studio Code logo"
                                ></img>
                                <span className="pt-2">VSC</span>
                                </div>
                            </a>
                            <a
                                href="https://en.wikipedia.org/wiki/REST"
                                alt="RestAPI"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <img
                                    type="button"
                                    style={{ maxWidth: "50px", width: "100%" }}
                                    src={APIIcon}
                                    alt="API"
                                ></img>
                                <span className="pt-2">RestAPI</span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="tech-content">
                        <div className="tech-title" onClick={() => handleArrowClick("learning")}>
                            <h3 className="tech-size">{i18next.t('learning')}</h3>
                            { window.innerWidth <= 1024 ? <ArrowDownIcon /> : <ArrowIcon /> }
                        </div>
                        <div className="tech-icons-list" id="learning">
                            <a
                                href="https://www.typescriptlang.org/"
                                alt="TypeScript"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <img
                                    type="button"
                                    style={{ maxWidth: "50px", width: "100%" }}
                                    src={TypescriptIcon}
                                    alt="TypeScript logo"
                                ></img>
                                <span className="pt-2">TypeScript</span>
                                </div>
                            </a>
                            <a
                                href="https://tailwindcss.com/"
                                alt="Tailwind"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <img
                                    type="button"
                                    style={{ maxWidth: "50px", width: "100%" }}
                                    src={TailwindIcon}
                                    alt="Tailwind logo"
                                ></img>
                                <span className="pt-2">Tailwind</span>
                                </div>
                            </a>
                            <a
                                href="https://reactnative.dev/"
                                alt="React Native"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <FontAwesomeIcon icon={faReact} size="4x" />
                                <span className="pt-2">React Native</span>
                                </div>
                            </a>
                            <a
                                href="https://www.java.com/"
                                alt="Java"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <FontAwesomeIcon icon={faJava} size="4x" />
                                <span className="pt-2">Java</span>
                                </div>
                            </a>
                            <a
                                href="https://aws.amazon.com/"
                                alt="AWS"
                                className="btn btn-background text-white"
                                target="_blank" rel="noreferrer">
                                <div className="d-flex flex-column align-items-center">
                                <FontAwesomeIcon icon={faAws} size="4x" />
                                <span className="pt-2">AWS</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};